import { IPipe } from '@app/api/interfaces/pipe.interface';
import { altTestProjectId, testProjectId } from '@mock/data/projects-mock.data';
import { pipesTestProjectData } from '@mock/data/pipes.test-project.server-data';

// TODO mock creates too big chunks. As option use import('@mock/data/pipes.test-project.server-data').then(
export const pipesTestProjectMockData = convertPipesToIPipeFormat(pipesTestProjectData);
let pipesAltTestProjectMockData: IPipe[] = [];

export const pipesByProjectIdMockData: Record<string, IPipe[]> = {
  [testProjectId]: pipesTestProjectMockData,
};

import('@mock/data/pipes.alt-test-project.server-data').then(m => {
  pipesAltTestProjectMockData = convertPipesToIPipeFormat(m.pipesAltTestProjectData);
  pipesByProjectIdMockData[altTestProjectId] = pipesAltTestProjectMockData;
});

function convertPipesToIPipeFormat(pipes: any[]): IPipe[] {
  return pipes.map(pipe => {
    return { ...pipe, id: pipe.id + '', nodes: pipe.nodes.map((node: any) => ({ ...node, id: node.id + '' })) };
  }) as IPipe[];
}
